module.exports = __webpack_public_path__ + "img/parnter_work.a88fb33d.svg";